import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    header: {
        position: 'sticky',
        top: "0rem",
    },
    title: {
        width: '100%',
        padding: '20px 0 20px 0',
        color: 'white',
        backgroundColor: theme.palette.primary.main,
    },
    tab: {
        width: '100vw',
        marginBottom: theme.spacing(1)
    },
    tabPanelsContainer: {
        marginTop: theme.spacing(1),
        paddingBottom: 58
    },
    tabPanel: {
        width: '100%'
    },
    card: {
        margin: '0 10px 0 10px',
        backgroundColor: '#EDEDED'
    },
    cardTitle:{
        display: 'flex',
        justifyContent: 'space-between',
        fontWeight: 'bold'
    },
    cardBody: {
        textAlign: 'left'
    },
    noMessageCard:{
        marginTop: theme.spacing(2)
    },
    footer: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        position: 'fixed',
        bottom: '0rem',
        width: '100%',
        '& .MuiButton-root':{
            width: '75%'
        }
    }
}));

export default useStyles;